/* eslint-disable no-throw-literal */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, memo, lazy, Suspense, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Upsell from '../../sections/upsell'
import ApplicableAdditionalCharge from '../applicable-additional-charge'
import Imprint from '../imprint';
import UsgProductDetails from '../usg-product-details';
import { redirectToURL } from '../../../../utils/url';
import { LineItemType } from '../../../../enums/lineItemType'
import ItemPriceDetails from '../item-price-details'
import '../../sections/product/index.scss';
import Accessory from '../accessories';
import { setTierPricesData } from '../../../../store/application';
import { config } from "../../../../utils/config";
import { getUsgProductUrl } from "../../../../utils/getUsgProductUrl";
import { mobileAndTabletDetection } from "../../../../utils/browser";
import { CartOperation } from "../../../../enums/cartOperation";
import i18n from '../../../../utils/translations/i18n';
import './index.scss';
import '../../elements/button/index.scss';
import { shouldComponentRender } from "../../../../utils/custom";
import { RootState } from "../../../../store";
import { useGetPricesDetailsMutation } from "../../../../store/pricing";
import AdditionalCharge from "../../../../models/additionalCharge";
import { useGetAccessoriesInfoQuery } from "../../../../store/product";
import { getTierPricesData, sortLineItems } from '../../../../utils/cart';
import { GetSizeQtyBoxes } from "../size-quantity-boxes";
import { HoverToZoomContainer } from "../hover-to-zoom";
import CONST from "../../../../utils/config/const.json"
import tierUtils from "../../../../utils/tier";
import { TierPricesData } from "../../../../models/tiers";
import PreviewPopup from '../../sections/preview-popup';
import PCCBanner from "../pcc-banner";

// lazy load
const AssortmentTemplates = lazy(() => import('../assortment-templates'));

const AssortmentTemplateBasedLineItem = ({customizationInfo}: any) => {
    return (
        <Suspense fallback={<></>}>
            <AssortmentTemplates pageName="shoppingBag" customizationInfo={customizationInfo}/>
        </Suspense>
    );
};

const Product = memo(({ cart, user, lineItemId, error}: {cart: any, user: any, lineItemId: string, error: any}) => {
    const {
        applicationState: { cartOperation, currentPage },
      } = useSelector((state: RootState) => state);
    const dispatch = useDispatch();
    const { t } = i18n;
    const [getPricesDetails] = useGetPricesDetailsMutation();
    const mainItem = cart?.lineItems[lineItemId]?.[0].data ?? {};
    const [isPricingDetailsLoaded, setIsPricingDetailsLoaded] = useState(false);
    const [showUpsellDetails, setShowUpsell] = useState(false);
    const [lineItemMap, setLineItemMap] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [showNonUsgimprint, setShowNonUsgimprint] = useState(false);
    
    type ModalHandler = {
        setShowModal: (show: boolean) => void;
    }

    const imprintModalRef = useRef<ModalHandler>(null);

    const handleCustomizeClick = () => {
      if (isMobileDevice && imprintModalRef?.current) {
        imprintModalRef?.current?.setShowModal(true);
      }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1023);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    
    useEffect(()=>{
        if (!isPricingDetailsLoaded) {
            getPricingDetails();
        }
    },[isPricingDetailsLoaded]);

    async function getPricingDetails(){
        try{
            const response: any = await getPricesDetails(mainItem.productKey?.toLowerCase());
            if(response.data){
                const productKey = mainItem.productKey;
                const tierPricesData: TierPricesData = getTierPricesData(response.data, mainItem.taxRate);
                const actualTiers = tierUtils.getTierForQuantity(tierPricesData.tierObject, mainItem.quantity) ?? {}
                if((actualTiers?.upsellQuantity > 0 ||  actualTiers?.upsellUnitPrice > 0) && !mainItem.multiSelectData.isExist){
                    setShowUpsell(true);
                }
                dispatch(setTierPricesData(productKey, tierPricesData));

                const lineItemType = mainItem?.customfield?.lineItemType;
                const fixedExtraCharges = response?.data?.fixedExtraCharges;
                const perUnitExtraCharges = response?.data?.perUnitExtraCharges;
                let newlineItemMap: any = lineItemMap;
    
                if(lineItemType?.toLowerCase() === LineItemType.MAINITEM) {
    
                    fixedExtraCharges.forEach((fixedCharge) => {
                        if (fixedCharge.isVisibleOnWeb && !fixedCharge.isAutoApply && (!fixedCharge.applicableChargeRules || !fixedCharge.applicableChargeRules.accessories || fixedCharge.applicableChargeRules.accessories.length === 0)) {
                            const newFixedCharge = { ...fixedCharge };
                            newFixedCharge.type = 'fixedExtraCharges';
                            fixedCharge = newFixedCharge;
                            
                            if (fixedCharge.applicableSkus) {
                                var uniqueFixedApplicableSkus = fixedCharge.applicableSkus.filter(function(v, i, a) { return a.indexOf(v) === i; });
                                uniqueFixedApplicableSkus.forEach((fixedSku)=>{
                                    if (fixedSku === mainItem?.customfield?.mcpSku){
                                        newlineItemMap.push({
                                            'type': LineItemType.ADDITIONALCHARGE,
                                            'data': new AdditionalCharge(newlineItemMap, fixedCharge, false),
                                            'code': fixedCharge.code,
                                            'appliedInCart': false
                                        })
                                    }
                                });
                            }
                            else {
                                newlineItemMap.push({
                                    'type': LineItemType.ADDITIONALCHARGE,
                                    'data': new AdditionalCharge(newlineItemMap, fixedCharge, false),
                                    'code': fixedCharge.code,
                                    'appliedInCart': false
                                })
                            }
                        }
                    });
    
                    perUnitExtraCharges.forEach((perUnitCharge) => {
                        if (perUnitCharge.isVisibleOnWeb && !perUnitCharge.isAutoApply) {
                            const newPerUnitCharge = { ...perUnitCharge };
                            newPerUnitCharge.type = 'perUnitExtraCharges';
                            perUnitCharge = newPerUnitCharge;
                            
                            if (perUnitCharge.applicableSkus) {
                                const uniquePerUnitApplicableSkus = perUnitCharge.applicableSkus.filter(function(v, i, a) { return a.indexOf(v) === i; });
                                uniquePerUnitApplicableSkus.forEach((perUnitSku)=>{
                                    if (perUnitSku === mainItem?.customfield?.mcpSku){
                                        newlineItemMap.push({
                                            'type': LineItemType.ADDITIONALCHARGE,
                                            'data': new AdditionalCharge(newlineItemMap, perUnitCharge, false),
                                            'code': perUnitCharge.code,
                                            'appliedInCart': false
                                        })
                                    }
                                });
                            }
                            else {
                                newlineItemMap.push({
                                    'type': LineItemType.ADDITIONALCHARGE,
                                    'data': new AdditionalCharge(newlineItemMap, perUnitCharge, false),
                                    'code': perUnitCharge.code,
                                    'appliedInCart': false
                                })
                            }
                        }
                    });
    
                    setLineItemMap(newlineItemMap);
                }
                setIsPricingDetailsLoaded(true);
            } else {
                throw('prices api failed to load');
            }
        } catch(error) {
            console.error("Error while getting prices data", error);
            redirectToURL(`/${config('locale_details').current_sitename}/`);
        }
    };

    //Fetch accessory information for product
    const { data: accessoryData } = useGetAccessoriesInfoQuery({ id: mainItem.productId,locale: config('locale') }, { skip: !mainItem?.productId });

    if(Object.keys(mainItem).length === 0 ) return <></>;

    const {customizationInfo} = mainItem;

    let appliedChargeCodes: string = '';

    const isLineItemPresent = () => cart?.lineItems[lineItemId]?.find(x => x?.data?.id === cartOperation?.mainItemId);

    const showApplicableCharge = () => cart.lineItems[lineItemId].map((lineItem) => {
        let showApplicableCharge = false;
        if (lineItem?.type === LineItemType.ADDITIONALCHARGE) {
            if (lineItem.appliedInCart) appliedChargeCodes += '-' + lineItem.code;
            if (!lineItem.appliedInCart) {
                showApplicableCharge = true;
            }
        }
        return showApplicableCharge;
    });
    const subItem: any = cart?.lineItems[mainItem.id].filter(lineitem => lineitem?.type === LineItemType.SUBITEM);
    const mainLineItem: any = cart?.lineItems[lineItemId]?.[0] ?? {};
    const combinedItems: any = [mainLineItem, ...subItem];
    const newOrder: any = mainItem?.apparelSortedSizes ?? [];
    const sortedLineItems = (newOrder.length > 0 && subItem.length > 0) ? sortLineItems(combinedItems,newOrder) : combinedItems;
    const usgProductImageUrl = getUsgProductUrl(mainItem);
    const isMobileDevice = mobileAndTabletDetection();

    const userSelectionInfo = mainItem?.productAttributes?.userSelectionInfo
    .filter(userSelection => userSelection.attribute.toLowerCase() !== CONST.PRODUCT_SIZE.toLowerCase() && userSelection.attribute.toLowerCase() !== CONST.PRODUCT_SIZE_V2.toLowerCase()) || [];

    const handleToggle = () => setShowAll(!showAll);

    const renderPriceAndOffers = () => {

        const renderError = (error) => {
            const operation = error?.errorObj?.operation;
            const isError = error?.isError;

            if (
                isError && (
                    (error?.errorObj?.mainItemId === mainItem?.id &&
                    (operation === CartOperation.ADDACCESSORY ||
                     operation === CartOperation.ADDUPSELL ||
                     operation === CartOperation.ADDMANUAL ||
                     operation === CartOperation.REMOVEITEM ||
                     operation === CartOperation.REMOVEMANUAL)) ||
                     
                    (cartOperation?.mainItemId === mainItem?.id && operation === CartOperation.GETCART) ||
                    (isLineItemPresent() && operation === CartOperation.REMOVEITEM)
                )
            ) {
                return <div className='error'>{error?.errorObj?.message}</div>;
            }
        };
    
        return (
            <div className="shopping-bag__item-details">
                {isMobile && mainItem.postCheckOutCustomization && <PCCBanner
                    className="shopping-bag-pcc-mobile-banner"
                />}
                <ItemPriceDetails cart={cart} lineItemId={lineItemId} isMobile={isMobile}/>
    
                {!mainItem.isOutOfStock && (
                    <div className={(isPricingDetailsLoaded && (showUpsellDetails || showApplicableCharge().some(Boolean)) || (accessoryData?.length > 0)) ? 'addOnsWrapper' : ''}>
                        {isPricingDetailsLoaded && showUpsellDetails && (
                            <Upsell cart={cart} lineItemId={lineItemId} />
                        )}

                        {isPricingDetailsLoaded && showApplicableCharge() && (
                            <ApplicableAdditionalCharge
                                cart={cart}
                                user={user}
                                lineItemId={lineItemId}
                                applicableAdditionalCharges={lineItemMap}
                                appliedChargeCodes={appliedChargeCodes}
                            />
                        )}

                        {accessoryData?.length > 0 && (
                            <Accessory
                                cart={cart}
                                lineItemId={lineItemId}
                                accessoryData={accessoryData}
                                mainItem={mainItem}
                            />
                        )}
                    </div>
                )}

    
                {renderError(error)}
            </div>
        );
    };    

    return (
        <>
            <div>
                <div className="shopping-bag__item">
                    <div className="row">
                        <div className="product-image">
                        {usgProductImageUrl &&
                            <div className='shopping_bag_usg_product_image_info'>
                                <UsgProductDetails productName={mainItem.name} productImageUrl={usgProductImageUrl} isMobileDevice={isMobileDevice} />
                            </div>
                        }
                        {!usgProductImageUrl &&
                            <>
                            <div className="shopping-bag__item-image" onClick={()=> isMobileDevice && setShowNonUsgimprint(true)}>
                                <img alt={mainItem.name} src={mainItem.productImageUrl}/>
                            </div>
                            <PreviewPopup imprintImageUrl={mainItem?.customizationInfo?.previewImageUrl} showModal={showNonUsgimprint} hideModal={()=>setShowNonUsgimprint(false)}/>
                            {customizationInfo && customizationInfo.isAssortedDesign ?
                            <>
                                <AssortmentTemplateBasedLineItem customizationInfo={customizationInfo} />
                            </> :
                            <>
                                {mainItem.customizationType !== "NULL"
                                    && <>
                                        <div className="customize-info shopping-bag" onClick={handleCustomizeClick}>
                                            <Imprint customizationInfo={mainItem.customizationInfo} customizationType={mainItem.customizationType} showPreview pageName={currentPage}
                                            modalRef={imprintModalRef}
                                            />
                                            {!mainItem?.postCheckOutCustomization && <HoverToZoomContainer />}
                                        </div>
                                    </>
                                }
                                {mainItem.customizationType === "NULL"
                                    && <>
                                        <div className="customize-info shopping-bag">
                                            {t('customize.no_customization_skip')}
                                        </div>
                                    </>
                                }
                            </>
                            }
                            </>
                        }
                        
                        </div>

                        <div className="product-detail">
                            <div className="product-header">
                                <span className="lineitem-name">
                                    {mainItem.name}
                                    <span className="family-name">
                                        ({mainItem.webCode || mainItem.productFamilyName})
                                    </span>
                                </span>
                            </div>
                            <>
                                {userSelectionInfo.length > 0 && (
                                    <ul>
                                        {userSelectionInfo.slice(0, showAll ? userSelectionInfo.length : 2).map((attribute, index) => (
                                            <li key={index}>
                                                <span>{attribute.attribute}: {attribute.value}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                                {userSelectionInfo.length > 2 && (
                                    <span onClick={handleToggle} className="see-more-text">
                                        {showAll 
                                            ? t('shopping_cart_details.see_less') 
                                            : `${t('shopping_cart_details.see_more')} (+${userSelectionInfo.length - 2})`
                                        }
                                    </span>
                                )}
                            </>
                            <div className="ship-msg">
                                {mainItem.isOutOfStock 
                                    ? t('oos.out_of_stock')
                                    : `${t('shopping_cart_details.ships_within_msg')?.replace('[X]', `${mainItem.productionTime}`)}*`
                                }
                            </div>
                            {mainItem?.multiSelectData?.isExist && !mainItem.isOutOfStock &&
                                <>
                                    <div className='shopping-bag-sizeQtyBoxContainer'>
                                        {GetSizeQtyBoxes(sortedLineItems, currentPage, lineItemId, mainItem?.apparelSortedSizes)}
                                    </div>
                                </>}
                            {!isMobile ? renderPriceAndOffers() : ''}
                        </div>
                    </div>
                    {isMobile ? renderPriceAndOffers() : ''}
                </div>
            </div>
        </>
    )
}, shouldComponentRender);

export default Product;